"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getTCCProxyRequest: ()=>getTCCProxyRequest
});
const signal_timeout_js_namespaceObject = require("../utils/signal-timeout.js");
const external_get_proxy_tcc_hostname_js_namespaceObject = require("./get-proxy-tcc-hostname.js");
const external_is_ttp_hostname_js_namespaceObject = require("./is-ttp-hostname.js");
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function get_tcc_proxy_request_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else get_tcc_proxy_request_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function getTCCProxyRequest(param) {
    let { namespace, key, isPreview, isTest, hostname, requestInit, useFallbackHostname } = param;
    const isTTP = (0, external_is_ttp_hostname_js_namespaceObject.isTTPHostname)(hostname);
    const proxyTccHostname = (0, external_get_proxy_tcc_hostname_js_namespaceObject.getProxyTCCHostname)({
        isTest,
        isTTP,
        isFallbackHostname: useFallbackHostname
    });
    const headers = new Headers();
    if (isPreview) headers.append('x-preview', '1');
    const request = new Request(`https://${proxyTccHostname}/${namespace}/${key}`, _object_spread_props(_object_spread({}, requestInit), {
        headers,
        credentials: isTTP ? 'include' : void 0,
        signal: (0, signal_timeout_js_namespaceObject.getTimeoutSignal)(8000)
    }));
    return request;
}
exports.getTCCProxyRequest = __webpack_exports__.getTCCProxyRequest;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getTCCProxyRequest"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
